module.exports = __webpack_public_path__ + "media/images/pledges-bg-f36a095e44fe6ddeb70a161d2dd3d897.png";